export function findCurrentTranslation(translations, lang, key = 'name', fallbackLang) {
  if (!translations) return ''

  let currentTranslation = translations.find((translation) => {
    return translation.locale === lang
  })

  if (!currentTranslation && fallbackLang)
    currentTranslation = translations.find((t) => t.locale === fallbackLang)

  if (!currentTranslation) currentTranslation = translations.find((t) => !!t[key])

  return currentTranslation && currentTranslation[key]
}
